import { create } from 'zustand'
import McDataServices from '../services/McDataServices'

const useAdminStore = create((set, get) => ({
  activities: [],
  loading: false,
  error: null,
  totalElements: 0,
  totalPages: 1,
  page: 0,
  size: 10,
  sort: 'createdAt,desc',
  filters: {
    username: ''
  },

  actions: {
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setActivities: (activities) => set({ activities }),
    setPagination: (page, totalElements, totalPages) => set({ page, totalElements, totalPages }),
    setPage: (page) => {
      set({ page })
      get().actions.fetchActivities()
    },
    setSize: (size) => {
      set({ size, page: 0 })
      get().actions.fetchActivities()
    },
    setFilters: (filters) => {
      set((state) => ({
        filters: { ...state.filters, ...filters },
        page: 0
      }))
      get().actions.fetchActivities()
    },
    setSort: (sort) => {
      set({ sort })
      get().actions.fetchActivities()
    },
    fetchActivities: async () => {
      const { page, size, sort, filters } = get()
      set({ loading: true, error: null })

      const payload = {
        page,
        size,
        sort,
        ...filters
      }

      Object.keys(payload).forEach(key => {
        if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
          delete payload[key]
        }
      })

      try {
        const response = await McDataServices.getActivities(payload)
        set({
          activities: response.content,
          totalElements: response.totalElements,
          totalPages: response.totalPages,
          loading: false
        })
      } catch (error) {
        set({ error: error?.detail || 'An error occurred', loading: false })
      }
    }
  }
}))

export const useAdminStoreActions = () => useAdminStore((state) => state.actions)
export const useAdminStoreData = {
  activities: () => useAdminStore((state) => state.activities),
  loading: () => useAdminStore((state) => state.loading),
  error: () => useAdminStore((state) => state.error),
  totalElements: () => useAdminStore((state) => state.totalElements),
  totalPages: () => useAdminStore((state) => state.totalPages),
  page: () => useAdminStore((state) => state.page),
  size: () => useAdminStore((state) => state.size),
  sort: () => useAdminStore((state) => state.sort),
  filters: () => useAdminStore((state) => state.filters)
}

export default useAdminStore
